let EmitterNFe = require("../MounterEmitterNfceService");
let IdentifyNFe = require("./MounterIdentifyNfeDomainService");
let DestinationNFe = require("./MounterDestinationNfeDomainService");
let ProductNFe = require("../MounterProductNFceDomainService");
let TransportInfoNFe = require("../MounterTransportInfoNFce");

async function execute(sales) {
  try {
    let emitterNFe = await EmitterNFe.execute(sales.enterprise.cnpj);
    let identifyNFe = await IdentifyNFe.execute(sales);
    let destinationNFe = await DestinationNFe.execute(sales);
    let productNFe = await ProductNFe.execute(sales, sales.enterprise);
    let transportInfo = await TransportInfoNFe.execute(sales);

    return mounterNfe(emitterNFe, identifyNFe, destinationNFe, productNFe, transportInfo);
  } catch (error) {
    return error;
  }
}

function mounterNfe(emitterNFe, identifyNFe, destinationNFe, productNFe, transportInfo) {
  return {
    emitterNFe: { ...emitterNFe },
    identifyNFe: { ...identifyNFe },
    destinationNFe: { ...destinationNFe },
    productsNFe: { ...productNFe },
    transportInfo: { ...transportInfo },
  };
}

module.exports = { execute };
